export const BOX_TYPE = {
	HARD: 1,
	VIRTUAL: 2
};
